import React from "react";
import {Columns, Form, Table} from "react-bulma-components";



class PrintTermsAcknowledgement extends React.Component{



    render(){
        let data = this.props.rental;
        let vehicleMake = (data.vehicle && data.vehicle.make) ? data.vehicle.make.name : "";
        let vehicleModal = (data.vehicle && data.vehicle.model) ? data.vehicle.model.name : "";
        let vehicleReg = (data.vehicle) ? data.vehicle.registration : "";
        let customerAddress = data.customer && (data.customer.address_line1 + " " + data.customer.town);
        let customerMobile = (data.customer && data.customer.company_phone_type === "Mobile") ? (data.customer.company_phone_country_code + data.customer.company_phone) : "";
        let customerLandLine = (data.customer && data.customer.company_phone_type === "Phone") ? (data.customer.company_phone_area_code +" "+ data.customer.company_phone) : "";


        return (
            <div>
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"} bordered>
                            <tbody>
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black table-header-bold"}>{`ACKNOWLEDGEMENT OF THE TERMS & CONDITIONS FOR ${data.department && data.department.name}.`}</td>
                                </tr>
                                <tr>
                                    <td colSpan={11} className={"border-black bold"} style={ {textAlign: "center"} }>{`I / WE CONFIRM RECEIPT OF ${data.department && data.department.name}'S TERMS & CONDITIONS      `}<Form.Checkbox/></td>
                                    <td colSpan={1} className={"border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-black table-header-bold border-black"}>IMPORTANT INFORMATION FOR YOUR ATTENTION</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <p>
                                            {`
                                            ALL OUR VEHICLES ARE FITTED WITH TELEMATICS TRACKING DEVICES AND FRONT FACING DASHCAMS - PLEASE UNDERSTAND THAT THESE DEVICES ARE FOR ${data.department && data.department.name} USE ONLY, UNLESS OTHERWISE AGREED.
                                            EXCESS MILEAGE IS CHARGED AS PER CONTRACT. THE HIRER ACCEPTS FULL LIABILITY FOR THE DAY TO DAY MAINTENANCE AND CHECKS OF THE VEHICLES INCLUDING FLUID LEVELS (OIL/ADBLUE/COOLANT).
                                            THE HIRER MUST REPORT ANY/ALL ENGINE MANAGEMENT LIGHT WARNINGS TO THE ${data.department && data.department.name} MAINTENANCE TEAM IMMEDIATELY. VEHICLE BREAKDOWNS (NOT DUE TO DRIVER FAULT) ARE COVERED BY OUR FREE RECOVERY SERVICE WITHIN A 50 MILE RADIUS OF NR16 1PH.
                                            IF BREAKDOWN OCCURS AND IS THE FAULT OF THE DRIVER THE RECOVERY COST IS FULLY CHARGEABLE TO THE CUSTOMER. FOR FURTHER DETAILS PLEASE SEE OUR RECOVERY POLICY ON OUR WEBSITE.
                                            `}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-black table-header-bold border-black"}>POST-HIRE RETURN OF VEHICLES</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <p>
                                            {`
                                             ALL VEHICLES NEED TO BE CLEAN UPON RETURN OR THEY WILL BEED TO BE WASHED PRIOR TO US BOOKING THE VEHICLE BACK IN.
                                             OUR RETURN TIMES ARE MONDAY TO FRIDAY 0730 TO 1730 AND SATURDAY 0800 TO 1300. OUTSIDE THESE HOURS THE VEHICLE REMAINS MY RESPONSIBILITY UNTIL THE HIRERS' HAVE WASHED IT AND CHECKED FOR ANY ADDITIONAL DAMAGE.
                                             ANY ADDITIONAL DAMAGE FOUND (OTHER THAN ALREADY ON THE VEHICLE CHECK IN SHEET WHEN SIGNED OUT) IS CHARGEABLE TO YOU.
                                             YOU WILL BE ASKED TO SIGN THE 'OFF HIRE DAMAGE REPORT' SECTION OF THE VEHICLE CHECK IN SHEET.
                                             I HEREBY AGREE THAT I AM RESPONSIBLE FOR ANY DAMAGE FOUND AFTER THE VEHICLE IS BOOKED IN.
                                            `}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black bold"} style={ {textAlign: "center"} }>I / WE CONFIRM THAT I / WE HAVE AGREED TO YOUR TERMS & CONDITIONS OF BUSINESS    <Form.Checkbox/></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black table-header-bold"}>STATEMENT OF LIABILITY</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <p>
                                            {`
                                             I AGREE THAT WHILST THIS RENTAL AGREEMENT IS IN FORCE, I WILL BE LIABLE, AS THE HIRER OF THIS VEHICLE OR ANY REPLACEMENT VEHICLE FOR THE FOLLOWING:
                                            `}
                                            <p style={ {textAlign: "center"}}>* ANY FIXED PENALTY NOTICE OR ANY NOTICE OF INTENDED PROSECUTION FOR DRIVING OFFENCES</p>
                                            <p style={ {textAlign: "center"}}>* CONGESTION CHARGED, DART CHARGES OR OTHER TOLL FEES</p>
                                            <p style={ {textAlign: "center"}}>* PARKING CHARGES OR FINES</p>
                                            * OTHER FINES OR CHARGES IMPOSED DURING THE PERIOD OF HIRE
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black bold"} style={ {textAlign: "center"}}>IMPORTANT: I HAVE READ AND UNDERSTOOD THE TERMS AND CONDITIONS THAT WILL APPLY TO THIS CONTRACT BEFORE SIGNING</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <p>
                                            {`
                                            * YOU AGREE THAT IF YOU BREAK THE TERMS OF THIS AGREEMENT WE CAN PASS YOUR PERSONAL INFORMATION TO CREDIT REFERENCE AGENCIES, DEBT COLLECTORS, THE POLICE OR ANY OTHER RELEVANT ORGANISATION.
                                            WE CAN ALSO FIVE THIS INFORMATION TO THE BRITISH VEHICLE RENTAL AND LEASING ASSOCIATION (BVRLA), WHICH CAN SHARE YOU PERSONAL INFORMATION WITH ITS MEMBERS TO PREVENT CRIME AND PROTECT THEIR ASSETS, AS ALLOWED UNDER THE DATA PROTECTION ACT.
                                            `}
                                            <p style={ {textAlign: "center"} } className={"bold"}>
                                                * ONLY SIGN THIS AGREEMENT IF YOU WISH TO BE BOUND BY THE TERMS AND CONDITIONS CONTRACT.
                                            </p>
                                            <p style={ {textAlign: "center"} } className={"bold"}>
                                                * ONLY SIGN THIS AGREEMENT IF YOU WISH TO BE BOUND BY THE TERMS AND CONDITIONS ABOVE.
                                            </p>
                                            <p className={"bold"}>
                                            * ONLY SIGN THIS AGREEMENT IF YOU CONFIRM TO MAKE PAYMENT BY DEBT / CREDIT CARD, CASH OR BANK TRANSFER (SUBJECT TO CONFIRMATION OF RECEIPT OF FUNDS)
                                            </p>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-grey border-black table-header-bold"}>INSURANCE PERMISSION</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <p className={"bold"}>{`I HEREBY GIVE FULL PERMISSION FOR ${data.department && data.department.name}, EVERYWHEN INSURANCE BROKERS TO ACCESS MY INSURANCE POLICY, ASSOCIATED DETAILS AND CLAIMS ON MY BEHALF.`}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"fill-grey border-black bold"}>NAME:</td>
                                    <td colSpan={6} className={"border-black"}>{data.customer ? data.customer.display_name : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"fill-grey border-black bold"}>COMPANY:</td>
                                    <td colSpan={6} className={"border-black"}>{data.customer ? data.customer.company_name : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"fill-grey border-black bold"}>ADDRESS:</td>
                                    <td colSpan={6} className={"border-black"}>{customerAddress}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"fill-grey border-black bold"}>POSTCODE:</td>
                                    <td colSpan={6} className={"border-black"}>{data.customer ? data.customer.postcode : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>MAKE / MODEL:</td>
                                    <td colSpan={4} className={"border-black"}>{vehicleMake+" / "+vehicleModal}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>REGISTRATION:</td>
                                    <td colSpan={4} className={"border-black"}>{vehicleReg}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>INSURER:</td>
                                    <td colSpan={4} className={"border-black"}>{data.insurer}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POLICY NUMBER:</td>
                                    <td colSpan={4} className={"border-black"}>{data.policy_number}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>SIGNED BY THE DRIVER</td>
                                    <td colSpan={4} className={"border-black"}></td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>NAME:</td>
                                    <td colSpan={4} className={"border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"fill-grey border-black bold"}></td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>DATE:</td>
                                    <td colSpan={4} className={"border-black"}></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </div>
        )

    }

}

export default PrintTermsAcknowledgement;